module.exports = "/_next/static/images/finish-onboarding-5fd86a625a7180903b653d45fca7d49d.svg";